<template>
    <div>
        <div class="page-header pr-0">
            <h2><a href="#"><i class="fas fa-tachometer-alt"></i></a></h2>
            <ol class="breadcrumbs">
                <li class="active"><span>{{ title }}</span></li>
            </ol>
        </div>
        <div class="card mt-5" v-loading="loading">
            <div class="card-header bg-info">
                <h3 class="my-0">{{ title }}</h3>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-4">
                        <x-date-picker label="Periodo"
                                       v-model="form.month"
                                       type="month"></x-date-picker>
                    </div>
                    <div class="col text-left" style="margin-top: 24px">
                        <el-button type="primary" :loading="loadingGenerate" @click.prevent="clickGenerate">
                            <template v-if="loadingGenerate">
                                Generando...
                            </template>
                            <template v-else>
                                Generar
                            </template>
                        </el-button>
                        <el-button type="primary"
                                   @click.prevent="clickDownload"
                                   class="mr-4"
                                   v-if="records.length > 0">Descargar
                        </el-button>
                    </div>
                </div>
                <div class="row mt-4" v-if="records.length > 0">
                    <div class="col-12">
                        <table class="table">
                            <thead>
                            <tr style="background-color: #eee">
                                <th class="text-center" v-for="(header, index) in headers"
                                    :key="'header-' + index"
                                    :style="{ backgroundColor: getColumnColor(index) }">
                                    {{ index + 1 }}
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(row, rowIndex) in records" :key="'row-' + rowIndex">
                                <td v-for="(cell, colIndex) in row"
                                    :key="'cell-' + rowIndex + '-' + colIndex"
                                    :style="{ backgroundColor: getColumnColor(colIndex) }">
                                    {{ cell }}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import XDatePicker from "../../../../../components/Form/XDatePicker.vue";
import XSelect from "../../../../../components/Form/XSelect.vue";

export default {
    name: 'InventoryStockExport',
    components: {XSelect, XDatePicker},
    data() {
        return {
            loading: false,
            loadingGenerate: false,
            title: null,
            resource: 'inventory_report_stock',
            error: {},
            form: {},
            filename: null,
            records: []
        }
    },
    computed: {
        headers() {
            if (!this.records.length) return []
            console.log(this.records[0].length);
            return Array(this.records[0].length).fill(null);
        }
    },
    async created() {
        this.initForm()
        this.title = 'Reporte de existencias - PLE'
    },
    methods: {
        getColumnColor(index) {
            return index % 2 === 0 ? "#fff" : "#eee"; // Par: #fff, Impar: #eee
        },
        initForm() {
            this.errors = {}
            this.form = {
                month: moment().format('YYYY-MM'),
            }
            this.filename = null
        },
        async clickGenerate() {
            this.loading = true
            this.loadingGenerate = true
            this.filename = null
            this.records = []
            await this.$http.post(`/${this.resource}/generate`, this.form)
                .then(response => {
                    const data = response.data
                    if (data.success) {
                        this.filename = data.data.filename
                        this.records = data.data.records
                    } else {
                        this.$message.error(data.message);
                    }
                    console.log(response.data)
                })
                .finally(() => {
                    this.loading = false
                    this.loadingGenerate = false
                })
        },
        clickDownload() {
            window.open(`/${this.resource}/download/${this.filename}`, '_blank')
        }
    }
}
</script>
